import { Box, Typography, makeStyles } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SGSButton, SGSFormDate } from 'components';
import SGSInputCurrency from 'components/SGSCurrency';
import SGSSelectCtr from 'components/SGSSelectCtrl';
import { allocationOptions } from 'features/arretTravail/models/StopInformation';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { InterruptionActivityS6202 } from '.';

type TableSalaireIncompletePeriodProps = {
    interruptions: InterruptionActivityS6202[];
    appendSalary: () => void;
    removeSalary: (index: number) => void;
};

export const TableSalaireIncompletePeriod: React.FC<TableSalaireIncompletePeriodProps> = ({ interruptions, appendSalary, removeSalary }) => {
    const classes = useStyles();
    const { trigger, control } = useFormContext();
    const [canAddMore, setCanAddMore] = useState(false);
    const watchedSalaires = useWatch({ name: 'interruptionActivityS6202.interruptions', control });

    useEffect(() => {
        const allFieldsHaveValues = watchedSalaires.every((item) => Object.keys(item).every((key) => key === 'id' || key === 'amount' || (item[key] !== null && item[key] !== '')));
        console.log(allFieldsHaveValues);
        setCanAddMore(allFieldsHaveValues);
    }, [watchedSalaires]);

    const handleAdd = async () => {
        const isValid = await trigger('interruptionActivityS6202');
        if (isValid) appendSalary();
    };

    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <TRow>
                        <THeaderBlue colSpan={4} align="center">
                            <Typography>CAS OU LA PERIODE DE REFERENCE N'A PAS ETE ENTIEREMENT ACCOMPLIE</Typography>
                        </THeaderBlue>
                        <THeaderBlue> </THeaderBlue>
                    </TRow>
                    <TableRow className={classes.tableHeader}>
                        <THeader colSpan={2}>
                            <Box>
                                <Typography className={classes.txtGreen}>INTERRUPTION DU TRAVAIL</Typography>
                            </Box>
                        </THeader>
                        <THeader>
                            <Box>
                                <Typography className={classes.txtGreen}>SI INTERRUPTION AUTORISEE</Typography>
                            </Box>
                        </THeader>
                        <THeader rowSpan={2}>
                            <Box>
                                <Typography className={classes.txtGreen}>Part salariale des cotisations à déduire</Typography>
                            </Box>
                        </THeader>
                        <THeader></THeader>
                    </TableRow>
                    <TableRow className={classes.tableHeader}>
                        <THeader>
                            <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                                <Typography className={classes.txtGreen} style={{ width: '50%', textAlign: 'center' }}>
                                    Du
                                </Typography>
                                <Typography className={classes.txtGreen} style={{ width: '50%', textAlign: 'center' }}>
                                    Au
                                </Typography>
                            </Box>
                        </THeader>
                        <THeader>
                            <Box>
                                <Typography className={classes.txtGreen}>Motif</Typography>
                            </Box>
                        </THeader>
                        <THeader>
                            <Typography className={classes.txtGreen}>Si la victime a subi une perte de salaire, indiquez le salaire brut perdu</Typography>
                        </THeader>

                        <THeader></THeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {interruptions.map((item, index) => (
                        <TableRow className="detail" key={item.id}>
                            <TCell>
                                <Box>
                                    <Box display="flex">
                                        <Box width="50%" style={{ marginRight: '15px' }}>
                                            <SGSFormDate inputVariant="outlined" name={`interruptionActivityS6202.interruptions.${index}.startDate`} />
                                        </Box>
                                        <Box width="50%">
                                            <SGSFormDate inputVariant="outlined" name={`interruptionActivityS6202.interruptions.${index}.endDate`} />
                                        </Box>
                                    </Box>
                                </Box>
                            </TCell>
                            <TCell style={{ width: '450px' }}>
                                <SGSSelectCtr fullWidth name={`interruptionActivityS6202.interruptions.${index}.reasonCod`} options={allocationOptions} variant="outlined" />
                            </TCell>
                            <TCell>
                                <SGSInputCurrency name={`interruptionActivityS6202.interruptions.${index}.amount`} />
                            </TCell>
                            <TCell>
                                <SGSInputCurrency name={`interruptionActivityS6202.interruptions.${index}.cotisationDeducted`} />
                            </TCell>
                            <TCell>
                                <Box style={{ width: '50px' }}>
                                    <SGSButton type="button" onClick={() => removeSalary(index)}>
                                        -
                                    </SGSButton>
                                </Box>
                            </TCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Box textAlign="center" className="mt-2">
                <SGSButton type="button" onClick={handleAdd} disabled={!canAddMore}>
                    +
                </SGSButton>
            </Box>
        </StyledTableContainer>
    );
};

const useStyles = makeStyles(() => ({
    header: {
        height: '54px',
    },
    dtEmis: {
        color: '#fff',
        fontSize: '0.8rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        height: '100%',
        width: '170px',
    },

    txtGreen: {
        color: '#2574A9',
        fontSize: '0.93rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },

    tableHeader: {},
}));

const StyledTableContainer = styled(TableContainer)(() => ({
    boxShadow: 'none',
    //border: '1px solid #3ba7ca',
    borderTop: 'none',
}));

const TRow = styled(TableRow)(() => ({
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
}));

const THeaderBlue = styled(TableCell)(() => ({
    backgroundColor: '#3399DB',
    color: '#FFF',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
    border: '1px solid #3399DB',
    '&:last-child': {
        background: 'none',
        border: 'none',
    },
}));

const THeader = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    background: '#F5F5F5',
    '&:last-child': {
        background: 'none',
        border: 'none',
    },
}));

const TCell = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    verticalAlign: 'top',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    background: '#FFF',
    '&:last-child': {
        background: 'none',
        border: 'none',
    },
}));
